var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gzhBox"},[_c('div',[_c('img',{attrs:{"src":_vm.ewm,"alt":""}}),_c('p',{staticClass:"color-9"},[_vm._v("请截图到微信内扫码")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }